import { createAppAsyncThunk } from 'src/store/utils/thunks';
import { wsEsSend } from '@skynet/data-ws-es';
import type {
  CreateSessionPayload,
  JsonWebMessageRequest,
  TradingMessageSession,
} from 'src/store/shared/tradingBots/types';
import { BotCommands } from 'src/store/shared/tradingBots/types';

export const createSessionWs = createAppAsyncThunk(
  'bots/createSessionWs',
  (payload: TradingMessageSession, thunkApi) => {
    return thunkApi.dispatch(
      wsEsSend({
        command: BotCommands.CreateSession,
        ...payload,
      }),
    );
  },
);

export const createSession = createAppAsyncThunk(
  'bots/createSession',
  async (data: CreateSessionPayload, thunkApi) => {
    const session = String(Math.floor(Math.random() * (99999999999 - 10000000000) + 10000000000));
    const payload = {
      ID: data.groupId,
      session,
    };
    await thunkApi.dispatch(createSessionWs(payload));
    return payload;
  },
);

export const sendMessageWs = createAppAsyncThunk(
  'bots/sendMessage',
  (data: Omit<JsonWebMessageRequest, 'command'>, thunkApi) => {
    return thunkApi.dispatch(
      wsEsSend({
        command: BotCommands.WebMessage,
        ...data,
      }),
    );
  },
);
